import React from 'react';
import "./contactpage.css";
import shape1 from "../../assets/wepb_images/contact-shape-1.png";
import shape2 from "../../assets/wepb_images/contact-shape-2.png";
import shape3 from "../../assets/wepb_images/contact-shape-3.png";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaInstagram,
  FaWhatsapp
} from "react-icons/fa";

function Contactpage() {
  return (
    <footer className="contact-section1" id='contact-section'>
      <div className="contact-container1">

        {/* Background Decorative Graphic Shapes */}
        <img src={shape1} alt="" className="contact-shape shape-left-blue" />
        <img src={shape2} alt="" className="contact-shape shape-bottom-pink" />
        <img src={shape3} alt="" className="contact-shape shape-top-right-blue" />

        {/* Left Card: Office Address */}
        <div className="contact-card">
          <div className="card-header">
            <span className="icon address-icon">📍</span>
            <h3>Office address</h3>
          </div>
          <div className="card-body">
            <p>No:21 Vinayaga Nagar,</p>
            <p>Okiyam Thoraipakkam,</p>
            <p>Chennai -600097.</p>
          </div>
        </div>

        {/* Center Card: Phone Number */}
        <div className="contact-card">
          <div className="card-header">
            <span className="icon phone-icon">📞</span>
            <h3>Phone Number</h3>
          </div>
          <div className="card-body">
            <p><a href="tel:+916380866249">+91 6380866249</a></p>
            <p><a href="tel:04435670376">044 35670376</a></p>
          </div>
        </div>

        {/* Right Card: Follow Us */}
        <div className="contact-card">
          <div className="card-header">
            <h3>Follow Us</h3>
          </div>
          <div className="card-body social-links">
            <a href="https://www.facebook.com/share/1G4PfTp6Bv/?mibextid=wwXIfr" target='_blank' rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/fazo_academy?utm_source=qr&igsh=MWR3djJ4cHJsejlnOA==" target='_blank'  rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://www.linkedin.com/company/fazo-academy/" target='_blank'  rel="noopener noreferrer"><FaLinkedinIn /></a>
            {/* <a href="#"><FaYoutube /></a> */}
            <a href="https://wa.me/916380866249" target="_blank" rel="noopener noreferrer" > <FaWhatsapp /> </a>

          </div>
        </div>

      </div>
    </footer>
  );
}

export default Contactpage;